import { useMutation } from '@tanstack/react-query';
import { client } from '@/services/api/axios.ts';

type PostUpdateStatusPushNotificationsResponse = {};

export const usePostUpdateStatusPushNotifications = (
  {
    onSuccess,
    onError,
  }: {
    onSuccess?: (data: PostUpdateStatusPushNotificationsResponse) => void;
    onError?: (error: unknown) => void;
  } = {
    onSuccess: undefined,
    onError: undefined,
  }
) => {
  return useMutation({
    mutationFn: async (payload: { authKey: string }) => {
      const deviceInfo = {
        userAgent: navigator.userAgent,
        language: navigator.language,
        screenResolution: `${screen.width}x${screen.height}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      const { data } = await client.post<{
        body: PostUpdateStatusPushNotificationsResponse;
      }>(`/notifications/subscription/heartbeat`, { ...payload, deviceInfo });

      return data.body;
    },
    onSuccess,
    onError,
  });
};
